module.exports = __webpack_public_path__ + "img/item-right.e13c5510.png";